import React from 'react';
import { FlexWrapper, Text } from '@intigral/shared';
import { Modal as SharedModal } from '@intigral/ui';
import { ModalProps as SharedModalProps } from '@intigral/ui/components/Modal';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';

export interface ModalProps extends SharedModalProps {
    // Add any additional props you want to extend here
    title?: string;
    body?: React.ReactNode;
    footer?: React.ReactNode;
    useFlexLayout?: boolean;
    isLoading?: boolean;
}

export const Modal: React.FC<ModalProps> = ({
    title,
    body,
    footer,
    useFlexLayout = true,
    children,
    isLoading,
    ...modalProps
}) => {
    return (
        <SharedModal {...modalProps} isLoading={isLoading}>
            {useFlexLayout ? (
                <FlexWrapper direction="column" gap="2x">
                    {title && (
                        <Text as="h4" variant="h4" margin="2x">
                            {title}
                        </Text>
                    )}
                    <FlexChild alignSelf="center">{body}</FlexChild>
                    {footer && (
                        <FlexChild direction="row" alignItems="center" gap="1x" justifyContent="end" marginTop="2x">
                            {footer}
                        </FlexChild>
                    )}
                </FlexWrapper>
            ) : (
                <>{children}</>
            )}
        </SharedModal>
    );
};
